// extracted by mini-css-extract-plugin
export default {"category_image":"CategoriesItem_category_image__NX8Fu","position_container":"CategoriesItem_position_container__c8OXf"};